import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';
import { abbrNumber } from '@hotjar/insights-common/lib/number';
import { Trend } from './Trend';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Content = styled.div`
  display: inline-flex;
  align-items: baseline;
`;

const Numerator = styled.span`
  ${tokens.text('header3')}
  line-height: 100%;
`;

const Denominator = styled.span`
  ${tokens.text('header5')}
  line-height: 100%;
  margin-right: 8px;
`;

type Props = {
  title: string;
  numerator: number;
  denominator: string;
  lossRate?: number;
  testId: string;
};

export function UnitRate({ title, numerator, denominator, lossRate, testId }: Props): JSX.Element {
  const showTrend = lossRate != null;

  const abbreviatedNumerator = abbrNumber(numerator);

  return (
    <Wrapper>
      <Text as="span" textType="subtitle3" textColor="text_disabled">
        {title}
      </Text>
      <Content>
        <Numerator data-testid={testId}>{abbreviatedNumerator}</Numerator>{' '}
        <Denominator>/ {denominator}</Denominator>
        {showTrend ? <Trend value={lossRate} /> : null}
      </Content>
    </Wrapper>
  );
}
